import React, { memo } from 'react';
import { motion } from 'framer-motion';
import { ArrowDown, Brain, Moon, Flame, Leaf, CheckCircle, Shield, AlertTriangle, Lock, Download, Zap } from 'lucide-react';
export function HeroSection() {
  const doors = [{
    id: 'mente',
    label: 'Niebla mental / memoria',
    icon: Brain,
    color: 'text-[#7C3AED]',
    bg: 'bg-[#F5F3FF]',
    border: 'border-[#DDD6FE]'
  }, {
    id: 'sueno',
    label: 'Sueño / insomnio',
    icon: Moon,
    color: 'text-[#1D4ED8]',
    bg: 'bg-[#EFF6FF]',
    border: 'border-[#BFDBFE]'
  }, {
    id: 'dolor',
    label: 'Dolor e inflamación',
    icon: Flame,
    color: 'text-[#B91C1C]',
    bg: 'bg-[#FEF2F2]',
    border: 'border-[#FECACA]'
  }, {
    id: 'digestion',
    label: 'Digestión / gases',
    icon: Leaf,
    color: 'text-[#166534]',
    bg: 'bg-[#F0FDF4]',
    border: 'border-[#BBF7D0]'
  }];
  return <section className="pt-0 pb-16 px-4 relative max-w-[800px] mx-auto text-center overflow-hidden" data-id="element-312">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-[600px] bg-[#2D5A3D] opacity-[0.03] blur-[100px] -z-10 rounded-full" data-id="element-313"></div>

      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.6
    }} data-id="element-314">
        {/* Pre-headline */}
        <div className="mb-4" data-id="element-315">
          <span className="inline-block py-1 px-3 rounded-full bg-[#F0F4EC] border border-[#2D5A3D]/20 text-[#2D5A3D] text-xs font-bold uppercase tracking-widest" data-id="element-316">
            Para adultos de 35+ que quieren recuperar su salud de forma natural
          </span>
        </div>

        {/* Headlines */}
        <h1 className="text-3xl md:text-5xl leading-[1.15] font-serif font-bold text-[#2C1810] mb-4 tracking-tight" data-id="element-317">
          La biblioteca de remedios naturales{' '}
          <span className="text-[#2D5A3D]" data-id="element-318">por síntomas</span>
          <span className="block text-xl md:text-2xl font-normal text-[#8B7355] mt-2" data-id="element-319">
            Edición América Latina
          </span>
        </h1>

        <h2 className="text-base md:text-lg text-[#5C4A3A] leading-relaxed mb-4 max-w-2xl mx-auto" data-id="element-320">
          Convierte ingredientes comunes de tu cocina en protocolos paso a paso.
          Diseñado para adultos de 35+ que quieren resultados reales y{' '}
          <span className="font-bold text-[#2C1810]" data-id="element-321">
            depender menos de soluciones rápidas.
          </span>
        </h2>

        {/* Product Image */}
        <div className="my-8 mx-auto relative group max-w-[340px]" data-id="element-322">
          <div className="absolute -inset-6 bg-gradient-to-b from-[#C17817]/30 via-[#2D5A3D]/20 to-[#C17817]/20 rounded-2xl blur-3xl opacity-60 group-hover:opacity-80 transition duration-1000" data-id="element-323"></div>
          <div className="absolute -inset-2 bg-gradient-to-r from-[#C17817]/20 via-transparent to-[#C17817]/20 rounded-xl blur-xl opacity-50" data-id="element-324"></div>
          <img src="https://cdn.magicpatterns.com/uploads/iEvJvZ7j4aAvadThqLH4ef/heylloyd-image-1771822033591.png" alt="La Medicina Natural - Recetas y Remedios Sencillos" className="relative w-full h-auto block rounded-xl shadow-[0_20px_60px_rgba(0,0,0,0.4),0_0_40px_rgba(193,120,23,0.2)] border border-[#C17817]/30" data-id="element-325" />
        </div>

        {/* Offer bar */}
        <motion.div initial={{
        opacity: 0,
        y: -10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.1,
        duration: 0.5
      }} className="mb-6 bg-[#2D5A3D] text-white rounded-xl px-4 py-3 flex flex-wrap items-center justify-center gap-x-4 gap-y-1 text-xs font-bold uppercase tracking-wide" data-id="element-326">
          <span className="flex items-center gap-1" data-id="element-327">
            <Zap className="w-3 h-3 text-[#FCD34D]" data-id="element-328" /> Oferta hoy: $6.97 USD
          </span>
          <span className="text-white/40 hidden sm:inline" data-id="element-329">·</span>
          <span className="flex items-center gap-1" data-id="element-330">
            <Download className="w-3 h-3 text-[#A7F3D0]" data-id="element-331" /> Acceso inmediato
          </span>
          <span className="text-white/40 hidden sm:inline" data-id="element-332">·</span>
          <span className="flex items-center gap-1 text-[#FCD34D]" data-id="element-333">
            3 bonos GRATIS
          </span>
          <span className="text-white/40 hidden sm:inline" data-id="element-334">·</span>
          <span className="flex items-center gap-1" data-id="element-335">
            <Shield className="w-3 h-3 text-[#A7F3D0]" data-id="element-336" /> Garantía 7 días
          </span>
        </motion.div>

        {/* Advertencia */}
        <motion.div initial={{
        opacity: 0,
        y: -10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.2,
        duration: 0.5
      }} className="mb-8 border-2 border-[#C17817]/40 bg-[#FFFBEB] rounded-xl p-5 text-left relative overflow-hidden" data-id="element-337">
          <div className="absolute top-0 left-0 w-1 h-full bg-[#C17817]" data-id="element-338"></div>
          <p className="text-[#C17817] font-bold text-xs uppercase tracking-widest mb-2 pl-3 flex items-center gap-1.5" data-id="element-339">
            <AlertTriangle className="w-3.5 h-3.5" data-id="element-340" /> Advertencia Psicológica
          </p>
          <p className="text-[#2C1810] text-sm leading-relaxed pl-3" data-id="element-341">
            Lo que estás a punto de leer va a hacerte sentir que{' '}
            <span className="font-bold" data-id="element-342">alguien finalmente entiende</span> lo
            que llevas años sintiendo pero nunca pudiste explicar.
          </p>
        </motion.div>

        {/* 4 DOORS */}
        <div className="mb-8" data-id="element-343">
          <p className="text-[#2C1810] font-bold text-base mb-4" data-id="element-344">
            ¿Qué quieres mejorar primero?
          </p>
          <div className="grid grid-cols-2 gap-3" data-id="element-345">
            {doors.map(door => {
            const Icon = door.icon;
            return <a key={door.id} href={`#${door.id}`} className={`flex items-center gap-3 p-3.5 rounded-xl border-2 ${door.bg} ${door.border} hover:shadow-md transition-all duration-200 text-left group`} data-id="element-346">
                  <div className={`p-2 rounded-full bg-white shadow-sm shrink-0`} data-id="element-347">
                    <Icon className={`w-4 h-4 ${door.color}`} data-id="element-348" />
                  </div>
                  <span className={`text-sm font-bold ${door.color} leading-tight`} data-id="element-349">
                    {door.label}
                  </span>
                  <ArrowDown className={`w-3 h-3 ${door.color} ml-auto shrink-0 -rotate-90 opacity-60 group-hover:opacity-100`} data-id="element-350" />
                </a>;
          })}
          </div>
        </div>

        {/* Proof Line */}
        <div className="flex items-center justify-center gap-2 text-xs font-medium text-[#5C4A3A] mb-8 uppercase tracking-wide flex-wrap" data-id="element-351">
          <CheckCircle className="w-4 h-4 text-[#2D5A3D]" data-id="element-352" />
          <span data-id="element-353">9 protocolos documentados</span>
          <span className="text-[#E8DFD0]" data-id="element-354">•</span>
          <span data-id="element-355">Ingredientes de tu cocina</span>
          <span className="text-[#E8DFD0]" data-id="element-356">•</span>
          <span data-id="element-357">Respaldo científico</span>
        </div>

        {/* CTA */}
        <a href="#comprar" className="block w-full bg-gradient-to-r from-[#B91C1C] to-[#991B1B] text-[#FEFCF6] font-bold py-5 px-6 rounded-xl text-lg uppercase tracking-wide shadow-[0_10px_20px_rgba(185,28,28,0.3)] hover:shadow-[0_15px_30px_rgba(185,28,28,0.4)] transform hover:-translate-y-1 transition-all duration-300 mb-4 animate-pulse-green flex items-center justify-center gap-2" data-id="element-358">
          <Leaf className="w-5 h-5" data-id="element-359" /> QUIERO ACCESO INMEDIATO POR $6.97 →
        </a>

        {/* Trust Micro-line */}
        <div className="flex items-center justify-center gap-3 text-xs text-[#5C4A3A] mb-12 flex-wrap" data-id="element-360">
          <span className="flex items-center gap-1" data-id="element-361">
            <Lock className="w-3 h-3 text-[#2D5A3D]" data-id="element-362" /> Pago seguro
          </span>
          <span className="text-[#E8DFD0]" data-id="element-363">|</span>
          <span className="flex items-center gap-1" data-id="element-364">
            <Download className="w-3 h-3 text-[#2D5A3D]" data-id="element-365" /> Descarga instantánea
          </span>
          <span className="text-[#E8DFD0]" data-id="element-366">|</span>
          <span className="flex items-center gap-1" data-id="element-367">
            <Shield className="w-3 h-3 text-[#2D5A3D]" data-id="element-368" /> Sin riesgo 7 días
          </span>
        </div>

        <div className="flex justify-center" data-id="element-369">
          <ArrowDown className="w-6 h-6 text-[#2D5A3D] animate-bounce opacity-60" data-id="element-370" />
        </div>
      </motion.div>
    </section>;
}